import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn } from "@elements/dom-utils";

export function init() {
    onFind('.js-casa-form', function (form) {
        // detect with mutation abserver if form is loaded
        let hasHandledTracking = false;

        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && !hasHandledTracking) {
                    handleTracking(form);
                    hasHandledTracking = true;
                    observer.disconnect();
                }
            }
        });

        // Configuration options for the observer
        const config = {
            childList: true, // Detect addition/removal of child elements
            attributes: true, // Detect attribute changes
            subtree: true, // Detect changes within all child nodes
        };

        // Start observing the target div
        observer.observe(form, config);
    });
}

function handleTracking(form) {
    let submit = findIn('button', form);

    on('click', function (evt) {
        let errorContainer = findIn('.form-group.has-error', form);

        if(errorContainer.style.display === 'none'){
            let fromDate = findIn('input[name="Anreise Tag"]', form).value; // format DD.MM.YYYY
            let toDate = findIn('input[name="Abreise Tag"]', form).value; // format DD.MM.YYYY
            let roomCount = findIn('input[name="Anzahl"]', form).value;

            console.log('push into dataLayer', {
                event: "request_sent",
                category: "basic",
                accommodation: "loewe",
                night_count: calculateDaysBetween(fromDate, toDate),
                date_start: fromDate,
                date_end: toDate,
                room_count: parseInt(roomCount)
            });

            window.dataLayer.push({
                event: "request_sent",
                category: "basic",
                accommodation: "loewe",
                night_count: calculateDaysBetween(fromDate, toDate),
                date_start: fromDate,
                date_end: toDate,
                room_count: parseInt(roomCount)
            })
        }
    }, submit);
}

function calculateDaysBetween(fromDate, toDate) {
    // Parse the date strings (DD.MM.YYYY) into Date objects
    const [fromDay, fromMonth, fromYear] = fromDate.split('.');
    const [toDay, toMonth, toYear] = toDate.split('.');

    const from = new Date(fromYear, fromMonth - 1, fromDay); // Months are 0-indexed in JavaScript
    const to = new Date(toYear, toMonth - 1, toDay);

    // Calculate the difference in time (milliseconds)
    const diffInMs = to - from;

    // Convert milliseconds to days
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays;
}